import "./AppLogos.css";

import React from "react";

import { useAppContext } from "../../classes/contexts/AppContext";
import { ReactComponent as LogoSpineSim } from "./SPINEsim.svg";
import AppInfo from "../appInfo/AppInfo";

const AppLogos = () => {
  const { showPopup } = useAppContext();

  const handleOpenAppInfo = () => {
    showPopup(<AppInfo />);
  };

  return (
    <div className="App-logos-container">
      <div onClick={handleOpenAppInfo}>
        <LogoSpineSim className="App-logo-spinesim" />
      </div>
    </div>
  );
};

export default AppLogos;
